import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { UtilModule } from '@gspwidget/util';
import { BgPropModule, WidgetDevkitModule } from '@gspwidget/widget-devkit';
import { TranslateModule } from '@ngx-translate/core';
import { NzAutocompleteModule } from 'ng-zorro-antd/auto-complete';
import { NzDatePickerModule } from 'ng-zorro-antd/date-picker';
import { NzDropDownModule } from 'ng-zorro-antd/dropdown';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzModalModule } from 'ng-zorro-antd/modal';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { AccordionModule } from 'ngx-bootstrap/accordion';
import { ColorPickerModule } from 'ngx-color-picker';
import { FilterModule } from './filter/filter.module';
import { PortletComponent } from './portlet/portlet.component';
import { TitleBarComponent } from './title-bar/title-bar.component';
import { WidgetComponent } from './widget/widget.component';
import { PortletModule } from './portlet/portlet.module';

@NgModule({
  declarations: [
    WidgetComponent,
    TitleBarComponent,
    // GridDesignerComponent,
  ],
  entryComponents: [
    WidgetComponent,
    TitleBarComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    HttpClientModule,
    ReactiveFormsModule,
    AccordionModule.forRoot(),
    ColorPickerModule,
    // Gridster2
    // TranslateModule.forRoot(),
    TranslateModule,
    NzAutocompleteModule, // TODO: 这些 module 的组织方式
    NzModalModule,
    NzDatePickerModule,
    // NzSelectModule,
    // 保证元部件在这层能获取到这里面的服务。
    // 不能仅注册在 root，因为服务的服务不保证在 root 上；
    // 不能都注册在 widget 里，因为会每个部件一个服务实例；
    // 注册在这保证元部件在此层找到同一个服务实例、并且服务的服务也在 module 里提供了。
    WidgetDevkitModule,
    UtilModule,
    FilterModule,
    NzDropDownModule,
    NzSelectModule,
    NzInputModule,
    BgPropModule,
    // PortletModule,
  ],
  exports: [
    WidgetComponent,
  ],
  providers: [
  ]
})
export class WidgetCoreModule { }
